import React from 'react';
import {Button, Label} from 'reactstrap';

import {AvGroup} from 'availity-reactstrap-validation';
import AvField from "../../../shared/component/form/AvField";
import Translate from "../../../shared/language/Translate";

import Toolbar from "../../../shared/component/toolbar/Toolbar";
import {toast} from "react-toastify";
import TenantService from "../../../shared/service/TenantService";

const defaultHsmSubnetAuto = {
    mebNetworkMask: '',
    reelNetworkMask: '',
};


export default class HsmSubnetSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hsmSubnetAuto: defaultHsmSubnetAuto,
            pageMode: null,
            disabledMask: false,
        };
        this.tenantService = new TenantService();
    }

    render() {
        return (
            <div>
                <Toolbar
                    display={true}>
                    <div className="p-toolbar-group-right">
                        <Button color="primary" className="float-right"
                                onClick={this.props.autoLoadForSubnetPool}>
                            &nbsp;
                            <Translate contentKey="entity.action.add">Getir</Translate>
                        </Button>
                        <Button color="primary" className="float-right"
                                onClick={this.props.closeDisplayDialogAuto}>
                            <Translate contentKey="entity.action.add">Vazgeç</Translate>
                        </Button>
                    </div>
                </Toolbar>
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <AvGroup>
                                <Label for="mebNetworkMaskBB">
                                    <Translate contentKey="hsmSubnet.mebNetworkMask">MEB NETWORK MASK</Translate>
                                    <span style={{color: 'red'}}>(*)</span>
                                </Label>
                                <AvField
                                    type="number"
                                    min="23"
                                    max="27"
                                    className="form-control"
                                    name="mebNetworkMaskBB"
                                    placeholder="00"
                                    value={this.state.hsmSubnetAuto.mebNetworkMask}
                                    onChange={this.__handleChange}
                                />
                            </AvGroup>
                            <AvGroup>
                                <Label for="reelNetworkMaskBB">
                                    <Translate contentKey="hsmSubnet.reelNetworkMask">REEL NETWORK MASK</Translate>
                                    <span style={{color: 'red'}}>(*)</span>
                                </Label>
                                <AvField
                                    type="number"
                                    min="30"
                                    max="32"
                                    className="form-control"
                                    name="reelNetworkMaskBB"
                                    placeholder="00"
                                    value={this.state.hsmSubnetAuto.reelNetworkMask}
                                    onChange={this.__handleChange}
                                />
                            </AvGroup>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    clearData = () => {
        this.setState({hsmSubnetAuto: Object.assign({}, defaultHsmSubnetAuto), pageMode: null, disabledMask: false});
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let hsmSubnetAuto = this.state.hsmSubnetAuto;
        hsmSubnetAuto[e.target.name.replace("BB", "")] = value;
        this.setState({hsmSubnetAuto: hsmSubnetAuto});
    }

    setAssetIdAndPageMode = (productId, pageMode) => {
        let hsmSubnetAuto = Object.assign({}, defaultHsmSubnetAuto);
        this.setState({hsmSubnet: hsmSubnetAuto, pageMode: pageMode});
    }

    getHsmSubnetAuto = () => {
        return this.state.hsmSubnetAuto;
    }
}